import clsx from 'clsx';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '@/app/providers/ThemeProvider';
import styles from './ThemeToggle.module.css';

/**
 * Beautiful Sun and Moon theme toggle with smooth transitions and glowing accents.
 */
export function ThemeToggle() {
  const { resolved, setPreference } = useTheme();

  return (
    <div className={styles.container} role="radiogroup" aria-label="Theme">
      <button
        type="button"
        role="radio"
        aria-checked={resolved === 'light'}
        aria-label="Light"
        title="Light theme"
        className={clsx(styles.option, styles.sunOption, resolved === 'light' && styles.active)}
        onClick={() => setPreference('light')}
      >
        <Sun className={styles.sunIcon} size={15} strokeWidth={2.2} />
      </button>

      <button
        type="button"
        role="radio"
        aria-checked={resolved === 'dark'}
        aria-label="Dark"
        title="Dark theme"
        className={clsx(styles.option, styles.moonOption, resolved === 'dark' && styles.active)}
        onClick={() => setPreference('dark')}
      >
        <Moon className={styles.moonIcon} size={15} strokeWidth={2.2} />
      </button>
    </div>
  );
}

